import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { NavLink } from "react-router-dom";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/work", label: "Work" },
  { to: "/book", label: "Book" },
  { to: "/cv", label: "CV" },
];

const linkClasses = ({ isActive }) =>
  `text-[15px] font-medium transition-colors ${
    isActive ? "text-ink" : "text-ink-soft hover:text-ink"
  }`;

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-paper/95 backdrop-blur">
      <nav
        className="mx-auto flex h-16 max-w-content items-center justify-between px-5 sm:px-8"
        aria-label="Primary"
      >
        <NavLink to="/" className="font-sans text-lg font-semibold tracking-tight text-ink">
          Simon Stead
        </NavLink>

        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={linkClasses}>
              {l.label}
            </NavLink>
          ))}
          <a
            href="mailto:steady@steadtec.com"
            className="rounded-full border border-ink px-4 py-2 text-[15px] font-medium text-ink transition-colors hover:border-accent hover:text-accent"
          >
            Get in touch
          </a>
        </div>

        <button
          type="button"
          onClick={() => setIsOpen((v) => !v)}
          className="-mr-2 p-2 text-ink md:hidden"
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
          aria-label={isOpen ? "Close menu" : "Open menu"}
        >
          {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {isOpen && (
        <div id="mobile-menu" className="border-t border-line bg-paper md:hidden">
          <div className="flex flex-col gap-1 px-5 py-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-3 text-base font-medium ${
                    isActive ? "bg-panel text-ink" : "text-ink-soft"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href="mailto:steady@steadtec.com"
              className="mt-2 rounded-lg bg-ink px-3 py-3 text-center text-base font-medium text-paper"
            >
              Get in touch
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
